const Index = resolve => require(['../Index'], resolve);
const Estudante = resolve => require(['../Estudante'], resolve);

export default [{
    name: 'estudantes.lista',
    path: 'estudantes',
    component: Index,
    meta: {
      requiresAuth: true,
      title: 'Busca Estudantes',
      menu: true,
      icon: 'fa fa-users'
    }
  },
  {
    name: 'estudantes.estudante',
    path: 'estudante/:id',
    component: Estudante,
    meta: {
      requiresAuth: true,
      title: 'Detalhes Estudante',
    }
  },
];



// WEBPACK FOOTER //
// ./src/pages/estudantes/routes/index.js